import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHeader } from '../../components/layout/PageHeader';
import ComingSoon from '../../components/common/ComingSoon';

export const SettingsPage: React.FC = () => {
  return (
    <Layout>
      <div className="flex-1 w-full">
        <div className="mx-auto w-full max-w-4xl px-6 py-8 space-y-6">
          <PageHeader title="Settings" subtitle="Teacher settings" />
          <ComingSoon title="Settings" description="This feature is under development." />
        </div>
      </div>
    </Layout>
  );
};

export default SettingsPage;

